module.exports = __webpack_public_path__ + "media/common/images/badges/gray/demon_administrativy-312220e9d3a174b7137579c2ecc7ef6b.svg";